exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer {\n  color: #546E7A;\n  line-height: 16px;\n  padding: 5px 10px;\n  border-bottom: 1px solid #e0e0e0;\n  min-height: 17px;\n}\n\n", ""]);

// exports
